module.exports = __webpack_public_path__ + "videos/34.37a8862.mp4";